import { render, staticRenderFns } from "./ArticlePage.vue?vue&type=template&id=ac1fed04&scoped=true"
import script from "./ArticlePage.vue?vue&type=script&lang=js"
export * from "./ArticlePage.vue?vue&type=script&lang=js"
import style0 from "./ArticlePage.vue?vue&type=style&index=0&id=ac1fed04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1fed04",
  null
  
)

export default component.exports